import { getApiUrl } from "../../environment";
import { useContext, useEffect, useState } from "react";
import api from "../api/api";
import { AppContext } from "../../App";

export default function EreciptQrPopup() {
	const { setEreciptQrPopup, setConfirm, lastOrderId } = useContext(AppContext);
	const [order, setOrder] = useState(false);
	const hasQr = Boolean(order && order.bill_url);

	useEffect(() => {
		if (lastOrderId) checkOrder();
	}, []);

	useEffect(() => {
		const interval = setInterval(async () => {
			if (order && order.bill_url) {
				clearInterval(interval);
				return;
			}
			await checkOrder();
		}, 5000);
		return () => clearInterval(interval);
	}, [lastOrderId, order]);

	const checkOrder = async () => {
		const res = await api.postProtected("/orders/get/" + lastOrderId + "/", {
			depth: 0,
			fields: ["id", "bill_url"],
		});
		if (res.success == 1) {
			setOrder(res.data);
		} else {
			setConfirm({
				title: "Errore",
				message: res.error,
			});
		}
	};

	return (
		<div className="erecipt erecipt-qr">
			<div className="container">
				<div className="header">
					<div className="title">Qr scontrino</div>
					<div className="subtitle">
						Attendi la generazione dell'immagine QRcode e il link dello scontrino
						digitale scaricabile
					</div>
				</div>
				{!hasQr && <div className="qr-loader" aria-label="Generazione QR in corso"></div>}
				{hasQr && (
					<div className="content">
						<img
							src={
								getApiUrl() + "/class/barcode.php?f=png&s=qr&w=500&h=500&d=" +
								encodeURIComponent(order.bill_url)
							}
						/>
						<div>
							<a
								href={order.bill_url}
								target="_blank"
								className="button button-1 qr-view-button"
							>
								Visualizza Scontrino
							</a>
						</div>
					</div>
				)}
				<button className="back-button" onClick={() => setEreciptQrPopup(false)}>
					Chiudi
				</button>
			</div>
		</div>
	);
}
